export default __webpack_public_path__ + "static/media/divisao-de-veiculos-sspeciais.1fc642be.svg";